export default "{{titulo}}\n";